import React, { Component } from 'react';
import * as helper from '../../utils/helper';
import { LoaderScreen, ProductBox } from '../common';
import styles from './styles.scss';
import request from '../../request';
import * as print from 'print';
import * as Helper from '../../utils/helper';
import { captureEvent } from '../../utils/sentryHelper';
import searchImage from '../../images/advanced-search.png';

const isAndroid = navigator.userAgent.toLowerCase().indexOf('android') > -1;
export default class PrintPartner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: false,
            error: null,
            filterText: '',
            filteredResults: [],
            resultsLayout: 'image',
        };
        this.emptyFilters = this.state.filterParams;
    }

    doLoad = async () => {
        const idPartner = this.props.match.params.idPartner;
        const filterText = this.state.filterText || idPartner;

        await request
            .get(
                `/_svc/inbound-po-api/partner/${idPartner}/lines/search/${filterText}`,
            )
            .then(response =>
                this.setState({
                    data: response,
                    filteredResults: response.lines,
                    filterText: '',
                }),
            )
            .catch(error => {
                this.setState({
                    data: error,
                    filteredResults: [],
                    filterText: '',
                });
                captureEvent((error && error.message) || error, {
                    logger: 'PrintPartner.componentDidMount',
                    extra: error,
                    level: Helper.getSentryErrorLevel(error.code),
                });
            });
    };

    printLabel = items => {
        const labels = items.map(product => {
            const qty = product.qty || 1;
            const label = `${product.title_en}`.trim();
            const data = { ...product, qty, label };
            return print.generateLabel(data);
        });

        print.print(labels);
    };

    applyFilters = () => {
        this.run(() => this.doLoad());
    };

    run = async fn => {
        this.setState({ loading: true });
        try {
            const ret = await fn();
            this.setState({ loading: false });
            return ret;
        } catch (e) {
            helper.error(e);
            this.setState({ loading: false });
        }
    };

    handleChange = evt => {
        const val = evt.target.value;

        this.setState(prevState => {
            return {
                filterText: val,
            };
        });
    };

    onKeyPress = event => {
        if (isAndroid) return;
        if (event.target.value && event.key === 'Enter') {
            this.applyFilters();
        }
    };

    renderFilterBar = filterText => {
        return (
            <div className={styles.filterArea}>
                <div className={styles.searchInput}>
                    <input
                        value={filterText}
                        onKeyPress={this.onKeyPress}
                        placeholder="Search by SKU, Barcode, Model Number or Brand"
                        name="gtin"
                        type="text"
                        onChange={evt => this.handleChange(evt)}
                    />
                </div>
                <div>
                    <button onClick={this.applyFilters}>Submit</button>
                </div>
                <a
                    className={styles.advancedSeachOpt}
                    onClick={() => window.history.back()}
                >
                    Basic
                </a>
            </div>
        );
    };

    renderContent = () => {
        const { filteredResults, resultsLayout, data } = this.state;

        if (filteredResults.length > 0) {
            return (
                <React.Fragment>
                    <div className={styles.resultsHeader}>
                        <p>{filteredResults.length} results found</p>
                    </div>
                    <div
                        className={`${styles.productList} ${
                            styles[resultsLayout]
                        }`}
                    >
                        {filteredResults.map((line, index) => (
                            <div
                                className={styles.productBoxContainer}
                                key={index + line.partner_sku}
                            >
                                <ProductBox
                                    layout={resultsLayout}
                                    item={line}
                                    printLabel={this.printLabel}
                                />
                            </div>
                        ))}
                    </div>
                </React.Fragment>
            );
        }

        return (
            <div className={styles.scanContainer}>
                {data && data.error ? (
                    <p className={styles.scanTitle}>{data.error}</p>
                ) : (
                    <React.Fragment>
                        <p className={styles.scanTitle}>Search Your Product</p>
                        <p className={styles.scanSubTitle}>
                            Start searching your product here by selecting a
                            parameter from the drop-down above to print the
                            barcode for transferring the products to noon
                            Warehouse.
                        </p>
                        <img
                            className={styles.scanImage}
                            src={searchImage}
                            alt="SKUScan"
                        />
                    </React.Fragment>
                )}
            </div>
        );
    };

    render() {
        const { filterText, loading } = this.state;
        const domain = window.location.hostname
            .split('.')
            .slice(-2)
            .join('.');
        const idPartner = this.props.match.params.idPartner;

        return (
            <div className={styles.homeScreen}>
                <div className={styles.viewSwitcher}>
                    <button
                        className={
                            this.state.view === 'search' ? styles.active : {}
                        }
                        onClick={() => this.setState({ view: 'search' })}
                    >
                        <i className="icon-search" />
                        Search
                    </button>
                    <button
                        className={
                            this.state.view === 'scan' ? styles.active : {}
                        }
                        onClick={() => this.setState({ view: 'scan' })}
                    >
                        <i className="icon-barcode" />
                        Scan
                    </button>
                    <button>
                        <a
                            href={`https://inbound-po.${domain}/asn/${idPartner}`}
                        >
                            ASN
                        </a>
                    </button>
                </div>
                {/* HEADER/FILTER START */}
                <div className={styles.header}>
                    <label>Start Searching a Product</label>
                </div>
                {this.renderFilterBar(filterText)}
                {/* HEADER/FILTER END */}

                {loading ? <LoaderScreen /> : this.renderContent()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PrintPartner/index.js